import { useEffect, useState } from "react";
import { Attribute, AttributeGroup, AttributeGroupType, AttributeProperty, BackgroundAttributes, ButtonAttributes, ButtonStateAttributes, ComponentProps, ContainerAttributes, FontTheme, GridAttributes, GridView, GridViewAttributes } from "react-builder";
import styled from "styled-components";
import { SportVideo, useSportVideos } from '../../providers/SportVideos';

const { Tab, TabList, TabPanel, Tabs } = require('react-tabs');

export class SportVideoCategory extends Attribute {

    @AttributeProperty({ type: 'String' })
    title: string = '';
    @AttributeProperty({ type: 'Image' })
    thumb?: string;
}

@AttributeGroup({
    blockName: 'SportVideoGallery',
    title: 'Sport Video Gallery',
    module: 'vod',
    icon: 'video-gallery'
})
export class SportVideoGalleryAttributes extends Attribute {
    @AttributeProperty({ type: 'object' })
    public grid = new GridViewAttributes().fromJSON({
        desktop: new GridAttributes().fromJSON({ columns: 4 }),
        mobile: new GridAttributes().fromJSON({ columns: 2 }),
    });

    @AttributeProperty({ type: 'Object', cssTarget: ' button' })
    button: ButtonStateAttributes = new ButtonStateAttributes().fromJSON({ static: new ButtonAttributes().fromJSON({ container: new ContainerAttributes().fromJSON({ background: new BackgroundAttributes().fromJSON({ color: 'transparent' }) }), font: new FontTheme().fromJSON({ color: 'initial' }) }) })

    @AttributeProperty({ type: 'Object', cssTarget: ' button.selected' })
    selectedButton: ButtonStateAttributes = new ButtonStateAttributes()

    @AttributeProperty({ title: 'Category', arrayLabelProperty: 'title', type: AttributeGroupType.List, arrayType: SportVideoCategory })
    categories: SportVideoCategory[] = []

    @AttributeProperty({ type: 'object' })
    public categoryGrid = new GridViewAttributes().fromJSON({
        desktop: new GridAttributes().fromJSON({ columns: 3 }),
        mobile: new GridAttributes().fromJSON({ columns: 1 }),
    });

    @AttributeProperty({ type: 'Object', cssTarget: ' .react-tabs__tab-list' })
    tabContainer: ContainerAttributes = new ContainerAttributes();

    @AttributeProperty({ type: 'Object' })
    cardButton: ButtonStateAttributes = new ButtonStateAttributes()

    @AttributeProperty({ type: 'Image' })
    playButton?: string;
}

export const SportVideoGalleryTheme = styled.div((props: { attributes: SportVideoGalleryAttributes }) => `

    .video-thumb{
        min-height: 300px;
        width: 100%;
        background: #eee;
    }

    .thumb-wrap{
        padding: 10px;
        
    }

    .video-img-wrap{
        position: relative;
        min-height: 90px;
        .play-overlay{
            display:none;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            background: rgba(0,0,0,.16);
            
            align-items: center;
            justify-content: center;

            img{
                max-width: 50%;
                max-height: 50%;
                min-height: 120px;
            }
        }

        &:hover .play-overlay{
            display: flex;
        }
    }

    .react-tabs__tab-list{

        ${props.attributes.tabContainer.toCSS()}

        display: flex;
        flex-direction: row;
        overflow: auto;
        margin: 0;
        padding: 0;

        ::-webkit-scrollbar {
        height: 8px;
        width: 8px;
        background: transparent;
        
        }

        /* Track */
        ::-webkit-scrollbar-track {
        background: #f1f1f1; 
        border-radius: 50px;
        }
        
        /* Handle */
        ::-webkit-scrollbar-thumb {
        background: red; 
        border-radius: 50px;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
        background: #555; 
        }
    }

    .react-tabs__tab {
        display: list-item;
        white-space: nowrap;
    }

    .react-tabs__tab{
        button{
            ${props.attributes.button.toCSS()}
        }
        button.selected{
            
            ${props.attributes.selectedButton.toCSS()}
        }
    }

    .full-details {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
        width: 95%;
        max-width: 1000px;
        padding: 20px;
        position: relative;
        background: #fff;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        position: fixed;
        }

        @media (max-width: 768px) {
        .full-details {
            overflow-y: auto;
            top: 46px;
            left: 0;
            transform: none;
            width: 100%;
            height: 100%;
            padding: 0px;
            border-radius: 0;
            box-shadow: none;

            .content{
                padding: 10px;
            }
        }
        }

        .full-details .content {
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        }

        @media (max-width: 768px) {
        .full-details .content {
            display: grid;
            gap: 20px;
        }
        }

        .full-details .thumb {
        width: 200px;
        min-width: 200px;
        max-width: 200px;
        margin-right: 20px;
        }

        @media (max-width: 768px) {
        .full-details .thumb {
            width: 100px;
            min-width: 100px;
            max-width: 100px;
            grid-column: 1 / 2;
            grid-row: 1;
            margin-right: 0;
            margin: 0;
        }
        }

        .full-details .close-icon {
            position: absolute;
            top: 10px;
            right: 10px;
        }

        @media (max-width: 768px) {
        .details-title {
            grid-column: 2 / 6;
            grid-row: 1;
            padding-right: 60px;
        }
        }

        .details-text {
        margin-right: 20px;
        }

        @media (max-width: 768px) {
        .details-text {
            margin-right: 0;
            grid-column: 1 / 5;
            grid-row: 2;
        }
        }

        .details-text > * {
        margin-bottom: 10px;
        }

        .details-text .description {
        line-height: 1.5;
        }

        @media (max-width: 768px) {
        .trailer-wrap {
            grid-column: 1 / 5;
            grid-row: 3;
        }
        .trailer-wrap h5 {
            margin-bottom: 10px;
        }
        }

        .dialog-fade {
            position: fixed;
            background: rgba(0,0,0,.3);
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            z-index: 100;
        }

        .genre {
            font-weight: 500;
            color: #bb0050;
            margin: 0px 0 15px 0;
        }

        .details-title.d-mobile{
            h5{
                margin-bottom: 0;
            }
        }
        
        .star-rating{
            display: flex;

            svg{
                height: 13px;
                width: 13px;
            }
        }

        .stars-wrap{
            margin: 0;
        }

        .thumb-details {
            display: flex;
            justify-content: space-between;
        }

        .video-player {
            width: 100%;
            background: #000;
            max-width: 900px;
        }

        .modal-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
        }

        .category-card{
            position: relative;
            margin: 10px;
            background: #ccc;

            img{
                min-height: 188px;   
            }


            button{
                ${props.attributes.cardButton.static.toCSS()}
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
            }
            &:hover{
                button{
                    ${props.attributes.cardButton.hover.toCSS()}
                }
            }
        }
`);

const SportVideoGallery = (props: ComponentProps<SportVideoGalleryAttributes>) => {

    const videoApi = useSportVideos();
    const [playedVideo, setPlayedVideo] = useState<SportVideo>();
    const [selectedCategory, setSelectedCategory] = useState<number>(0);


    useEffect(() => {
        if (videoApi.loadVideos && videoApi.videos?.length <= 0) {
            videoApi.loadVideos().then((r) => {
            });
        }

    }, [videoApi.loadVideos]);

    useEffect(() => {
        if (!selectedCategory) {
            // setSelectedCategory(-1);
        }
    }, [videoApi.videos])

    const getCategory = (_c: SportVideoCategory): {
        category: string;
        videos: SportVideo[];
    } | undefined => {
        return videoApi?.videosByCategory?.find((c) => c.category.replaceAll(" ", "").toLowerCase() == _c.title?.replaceAll(" ", "").toLowerCase());
    }

    const buildVideoCard = (video: SportVideo, i: number, key?: any) => <div key={key} onClick={(e) => setPlayedVideo(video)} className="thumb-wrap" >
        <div className='video-img-wrap' >
            <img src={video.previewUrl} />
            <div className='play-overlay' >
                {props.attributes.playButton && <img src={props.attributes.playButton} />}
            </div>
        </div>
        <h5>{video.title}</h5>
    </div>

    const buildVideoPlayer = (video: SportVideo) => <><div className="dialog-fade" onClick={(e) => setPlayedVideo(undefined)} ><div className="modal-content" uib-modal-transclude="">
        <video className="video-player ng-scope" onClick={(e) => { e.stopPropagation() }} controls={true} controlsList="nodownload" src={video.movieUrl}>
        </video></div></div></>

    const buildCategoryTab = (c: SportVideoCategory, i: number) => <div key={i} onClick={(e) => setSelectedCategory(i + 1)} className='category-card'>
        {c.thumb && <img src={c.thumb} />}
        <button>
            {c.title}
        </button>
    </div>

    const [page, setPage] = useState<number>(1);
    const pageSize: number = 12;

    const getDisplayCount = () => page * pageSize;

    return (
        <SportVideoGalleryTheme {...props} >
            <Tabs selectedIndex={selectedCategory} onSelect={(index: number) => setSelectedCategory(index)}>

                <TabList>
                    <Tab key={-1}><button className={`${0 == selectedCategory ? 'selected' : ''}`} >Overview</button></Tab>
                    {props.attributes.categories?.map((c: any, i: any) => <Tab key={i}><button className={`${i + 1 == selectedCategory ? 'selected' : ''}`} >{c.title}</button></Tab>)}
                </TabList>

                {/* overview tab */}
                <TabPanel key={-1} >
                    <GridView
                        attributes={props.attributes.categoryGrid}
                        length={props.attributes.categories.length}
                        itemBuilder={(i: any, k: any) => buildCategoryTab(props.attributes.categories[i], i)}
                    >
                        <></>
                    </GridView>
                </TabPanel>
                {props.attributes.categories?.map((u: any, i: number) => {

                    const c = getCategory(u);
                    return <TabPanel key={i}>

                        {(c?.videos?.length ?? 0) > 0 && <div ><GridView
                            attributes={props.attributes.grid}
                            length={Math.min(c?.videos?.length ?? 0, getDisplayCount())}
                            itemBuilder={(i: any) => buildVideoCard(c!.videos[i], i)}
                        ><></></GridView>
                            {c!.videos?.length > getDisplayCount() && <div className="text-center" >
                                <button onClick={(e) => setPage(page + 1)}>Load more</button>
                            </div>}</div>}
                    </TabPanel>;
                }
                )}

            </Tabs>
            {playedVideo && buildVideoPlayer(playedVideo)}
        </SportVideoGalleryTheme>
    )
}

SportVideoGallery.prototype.Props = SportVideoGalleryAttributes;

export default SportVideoGallery;